import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllUsersSlice = createSlice({
  name: "getAllUsers",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data.data;
      state.pagination = action.payload.pagination;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    updateStatus(state, action) {
      const { id, isActive } = action.payload;
      state.data = state.data.map((user) =>
        user.id === id ? { ...user, isActive: isActive } : user
      );
      // console.log(id);
    },
  },
});

const { name, actions, reducer } = getAllUsersSlice;
const getAllUsersAction = createAction(name);
const updateUserStatusAction = actions.updateStatus;

export {
  getAllUsersAction,
  updateUserStatusAction,
  actions as getAllUsersActions,
  reducer as getAllUsersReducer,
};
